import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';

const Faq = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqItems = [
    {
      question: "What is Ziyarat Guide?",
      answer:
        "Ziyarat Guide is a comprehensive platform offering guidance about pilgrimage sites, historical events, accommodations, and practical tips for visitors to Karbala and other sacred locations."
    },
    {
      question: "How do I plan my visit to Karbala?",
      answer:
        "You can plan your visit by checking our Logistics, Accommodations, and Safety Tips pages. We provide travel advice, hotel options, and practical guidance to ensure a smooth pilgrimage experience."
    },
    {
      question: "Which shrines can I learn about here?",
      answer:
        "We cover major shrines like the Shrine of Imam Hussain (AS), Al-Abbas Shrine, Al-Mukhayam Shrine, Shrine of Two Sons of Muslim Ibn Aqeel, and Shrine of Imam Ali (AS). Each page has detailed history, significance, and images."
    },
    {
      question: "Is this guide suitable for first-time pilgrims?",
      answer:
        "Yes, all content is structured to help both first-time pilgrims and returning visitors. You can find step-by-step guidance, tips on rituals, recommended visits, and FAQs."
    },
    {
      question: "Can I trust the historical information?",
      answer:
        "All historical and religious information is sourced from authentic references, including Qur’an, Hadith, and recognized scholarly interpretations. We aim to present it clearly and respectfully."
    }
  ];

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <>
      <Helmet>
        <title>FAQs | Ziyarat & Travel Questions Answered</title>
        <meta
          name="description"
          content="Find clear answers to common questions about ziyarat, travel planning, safety, shrines, and visiting Karbala or Najaf."
        />
        <meta property="og:title" content="FAQs | Ziyarat & Travel Questions Answered" />
        <meta
          property="og:description"
          content="Frequently asked questions about pilgrimage sites, travel guidance, and visiting Karbala and Najaf."
        />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

      <div className="faq-page">
        <div className="faq-header">
          <h1>Frequently Asked Questions (FAQ)</h1>
          <p>Find answers to common questions about pilgrimages, sites, and the guide itself.</p>
        </div>

        <div className="faq-accordion">
          {faqItems.map((item, index) => (
            <div key={index} className="faq-item">
              <div
                className={`faq-question ${activeIndex === index ? 'active' : ''}`}
                onClick={() => toggleAccordion(index)}
              >
                {item.question}
                <span className="faq-icon">{activeIndex === index ? '−' : '+'}</span>
              </div>
              {activeIndex === index && (
                <div className="faq-answer">
                  <p>{item.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Faq;
